var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line, _path31, _polyline, _line2, _path32, _path33, _path34, _polyline2, _line3, _line4, _polyline3, _g, _g2, _g3, _g4, _path35, _polygon, _path36, _polygon2, _path37, _path38, _path39, _polygon3, _path40, _path41, _g5, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 896.14 896.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .st2 {\n        fill: #1a1a1a;\n      }\n\n      .st2, .st3, .st4, .st5, .st6 {\n        font-family: Arial-BoldMT, Arial;\n        font-weight: 700;\n      }\n\n      .st2, .st6 {\n        font-size: 70.39px;\n      }\n\n      .st3 {\n        font-size: 33.87px;\n      }\n\n      .st7 {\n        fill: #0001fc;\n      }\n\n      .st4 {\n        font-size: 25px;\n      }\n\n      .st8, .st6 {\n        fill: #fff;\n      }\n\n      .st9 {\n        fill: red;\n      }\n\n      .st5 {\n        font-size: 28px;\n      }\n\n      .st10 {\n        fill: #ffd600;\n      }\n\n      .st11 {\n        fill: #006300;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.96,450.07v135.52c0,.53.21,1.04.59,1.41l74.03,74.1-72.69,73.17-108.82-108.82v-175.39h106.89M158.96,448.07H48.07v178.22l110.82,110.82,75.51-76.01-75.44-75.51v-137.52h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.4,663.93l74.58,74.66c.38.38.88.59,1.41.59h135.53v106.89h-175.25l-108.96-108.96,72.69-73.17M234.4,661.1l-75.51,76.01,110.96,110.96h178.08v-110.89h-137.53l-76-76.08h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M378.97,587.59l-34.55,73.01-34.61,73.15-72.57-72.65,73.99-73.52h67.75M382.13,585.59h0,0ZM382.13,585.59h-71.73l-76,75.51,76,76.08,35.83-75.72,35.9-75.87h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.4,516.3v68.45l-73.99,73.52-72.03-72.1,73.1-34.98,72.93-34.89M310.4,513.13l-75.79,36.26-75.65,36.2,75.44,75.51,76-75.51v-72.46h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.93,663.46v71.72h-132.37l33.94-71.72h98.43M447.93,661.46h-101.7l-35.83,75.72h137.53v-75.72h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.78,500.11c6.68,3,13.78,4.66,21.15,4.92v154.43h-96.54l34.55-73.01,40.85-86.34M423.83,497.45l-41.7,88.14-35.9,75.87h101.7v-158.39c-8.65-.02-16.83-2.04-24.1-5.62h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M397.21,473.81c5.28,10.41,13.69,19.02,23.99,24.53l-40.33,85.25h-68.46v-69.2l84.81-40.58M398.14,471.15l-87.74,41.98v72.46h71.73l41.7-88.14c-11.29-5.55-20.4-14.86-25.69-26.3h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.61,450.07v98.06l-71.65,34.29v-132.35h71.65M234.61,448.07h-75.65v137.52l75.65-36.2v-101.32h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M391.1,450.07c.24,6.98,1.72,13.73,4.42,20.11l-85.99,41.14-72.93,34.89v-96.15h154.49M393.07,448.07h-158.46v101.32l75.79-36.26,87.74-41.98c-3.26-7.02-5.07-14.84-5.07-23.08h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M661.17,664.56l73.17,72.69-108.82,108.82h-175.39s0-106.89,0-106.89h135.52c.53,0,1.04-.21,1.41-.58l74.1-74.03M450.14,737.18h0,0M661.17,661.74l-75.51,75.44h-137.52s0,110.89,0,110.89h178.22s110.82-110.82,110.82-110.82l-76.01-75.51h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M739.25,448.21h0,0M846.14,450.21v175.25s-108.96,108.96-108.96,108.96l-73.17-72.69,74.66-74.58c.38-.38.59-.88.59-1.41v-135.53h106.89M848.14,448.21h-110.89v137.53s-76.08,76-76.08,76l76.01,75.51,110.96-110.96v-178.08h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M587.66,517.17l73.01,34.55,73.15,34.61-72.65,72.57-73.52-73.99v-67.75M585.66,514.01v71.73l75.51,76,76.08-76-75.72-35.83-75.87-35.9h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M584.83,587.74l73.52,73.99-72.1,72.03-34.98-73.1-34.89-72.93h68.45M585.66,585.74h-72.46l36.26,75.79,36.2,75.65,75.51-75.44-75.51-76h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M663.53,448.21h0,0M735.25,450.21v132.37s-71.72-33.94-71.72-33.94v-98.43h71.72M737.25,448.21h-75.72v101.7s75.72,35.83,75.72,35.83v-137.53h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M659.53,450.21v96.54s-73.01-34.55-73.01-34.55l-86.34-40.85c3-6.68,4.66-13.78,4.92-21.15h154.43M661.53,448.21h-158.39c-.02,8.65-2.04,16.83-5.62,24.1l88.14,41.7,75.87,35.9v-101.7h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M498.41,474.95l85.25,40.33v68.46h-69.2l-40.58-84.81c10.41-5.28,19.02-13.69,24.53-23.99M497.52,472.31c-5.55,11.29-14.86,20.4-26.3,25.69l41.98,87.74h72.46v-71.73l-88.14-41.7h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2,663.53l34.29,71.65h-132.35v-71.65h98.06M549.46,661.53h-101.32v75.65h137.52s-36.2-75.65-36.2-75.65h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M470.25,500.62l41.14,85.99,34.89,72.93h-96.15v-154.49c6.98-.24,13.73-1.72,20.11-4.42M450.14,503.07h0,0M471.22,498c-7.02,3.26-14.84,5.07-23.08,5.07v158.46s101.32,0,101.32,0l-36.26-75.79-41.98-87.74h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M737.25,161.86l108.82,108.82v175.39h-106.89v-135.52c0-.53-.21-1.04-.59-1.41l-74.03-74.1,72.69-73.17M737.25,159.03l-75.51,76.01,75.44,75.51v137.52h110.89v-178.22l-110.82-110.82h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M625.46,50.07l108.96,108.96-72.69,73.17-74.58-74.66c-.38-.38-.88-.59-1.41-.59h-135.53V50.07h175.25M626.29,48.07h-178.08v110.89h137.53l76,76.08,75.51-76.01-110.96-110.96h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M586.33,162.38l72.57,72.65-73.99,73.52h-67.75l34.55-73.01,34.61-73.15M585.74,158.96l-35.83,75.72-35.9,75.87h71.73l76-75.51-76-76.08h0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M661.73,237.86l72.03,72.1-73.1,34.98-72.93,34.89v-68.45l73.99-73.52M661.74,235.04l-76,75.51v72.46l75.79-36.26,75.65-36.2-75.44-75.51h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M582.58,160.96l-33.94,71.72h-98.43v-71.72h132.37M585.74,158.96h-137.53v75.72h101.7l35.83-75.72h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M546.75,236.68l-34.55,73.01-40.85,86.34c-6.68-3-13.78-4.66-21.15-4.92v-154.43h96.54M549.91,234.68h-101.7v158.39c8.65.02,16.83,2.04,24.1,5.62l41.7-88.14,35.9-75.87h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M583.74,312.55v69.2l-84.81,40.58c-5.28-10.41-13.69-19.02-23.99-24.53l40.33-85.25h68.46M585.74,310.55h-71.73l-41.7,88.14c11.29,5.55,20.4,14.86,25.69,26.3l87.74-41.98v-72.46h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M735.18,313.72v132.35h-71.65v-98.06l71.65-34.29M737.18,310.55l-75.65,36.2v101.32h75.65v-137.52h0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M659.53,349.92v96.15h-154.49c-.24-6.98-1.72-13.73-4.42-20.11l85.99-41.14,72.93-34.89M661.53,346.75l-75.79,36.26-87.74,41.98c3.26,7.02,5.07,14.84,5.07,23.08h158.46v-101.32h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.07,448.07"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.07,448.07"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.07,448.07"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 848.07,
    y1: 448.07,
    x2: 448.07,
    y2: 448.07
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.46,46.82"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "393.07 447.93 426.21 447.93 447.05 447.93 447.34 447.93 448.07 447.93"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 158.96,
    y1: 448.21,
    x2: 158.96,
    y2: 447.93
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.22,238.63"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.57,238.63"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.69,423.83l25.12,11.88,8.7,4.12,8.1,3.83s.01,0,.01,0l7.45,3.53.5.24"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "424.99 398.14 438.98 427.39 443.02 435.82 443.02 435.83 446.03 442.11 448.07 446.38 448.57 447.43"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 234.68,
    y1: 448.21,
    x2: 234.68,
    y2: 447.93
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 448.57,
    y1: 234.61,
    x2: 448.07,
    y2: 234.61
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "448.07 393.07 448.07 428.23 448.07 446.38 448.07 447.19 448.07 447.93 448.07 448.07"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "49.07 847.07 49.07 628.7 267.44 847.07 49.07 847.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07,631.12l107.41,107.41,107.55,107.55H50.07v-214.95M48.07,626.29v221.78h221.78l-110.96-110.96-110.82-110.82h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "628.7 847.07 847.07 628.7 847.07 847.07 628.7 847.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.07,631.12v214.95s-214.95,0-214.95,0l107.41-107.41,107.55-107.55M848.07,626.29l-110.96,110.96-110.82,110.82h221.78s0-221.78,0-221.78h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "628.7 49.07 847.07 49.07 847.07 267.44 628.7 49.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.07,50.07v214.95l-107.41-107.41-107.55-107.55h214.95M848.07,48.07h-221.78l110.96,110.96,110.82,110.82V48.07h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "49.07 49.07 267.44 49.07 49.07 267.44 49.07 49.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.02,50.07l-107.41,107.41-107.55,107.55V50.07h214.95M269.85,48.07H48.07v221.78l110.96-110.96,110.82-110.82h0Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M446.07,50.07v106.89h-135.52c-.53,0-1.04.21-1.41.59l-74.1,74.03-73.17-72.69,108.82-108.82h175.39M448.07,48.07h-178.22l-110.82,110.82,76.01,75.51,75.51-75.44h137.52V48.07h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "235.04 234.4 158.96 310.4 158.96 447.93 48.07 447.93 48.07 269.85 159.03 158.89 235.04 234.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M235.03,237.23l73.52,73.99v67.75l-73.01-34.55-73.15-34.61,72.65-72.57M235.04,234.4l-76.08,76,75.72,35.83,75.87,35.9v-71.73l-75.51-76h0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346.75 234.61 310.55 158.96 235.04 234.4 310.55 310.4 383.01 310.4 346.75 234.61"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M160.96,313.56l71.72,33.94v98.43h-71.72v-132.37M158.96,310.4v137.53h75.72v-101.7l-75.72-35.83h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.69,423.83c-3.58,7.27-5.6,15.45-5.62,24.1h-158.39v-101.7l75.87,35.9,88.14,41.7Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M381.75,312.4l40.58,84.81c-10.41,5.28-19.02,13.69-24.53,23.99l-85.25-40.33v-68.46h69.2M383.01,310.4h-72.46v71.73l88.14,41.7c5.55-11.29,14.86-20.4,26.3-25.69l-41.98-87.74h0Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "448.07 158.96 448.07 234.61 346.75 234.61 310.55 158.96 448.07 158.96"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.07,234.61v158.46c-8.24,0-16.06,1.81-23.08,5.07l-41.98-87.74-36.26-75.79h101.32Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.36,448.57"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.07,448.07v.14c-.02,8.64-2.04,16.81-5.62,24.08-5.53,11.29-14.83,20.4-26.26,25.7-7.03,3.26-14.86,5.08-23.12,5.08h-.14c-8.62-.02-16.77-2.03-24.03-5.59-11.28-5.51-20.38-14.79-25.69-26.18-3.3-7.06-5.14-14.93-5.14-23.23v-.14c.02-8.65,2.04-16.83,5.62-24.1,5.55-11.29,14.86-20.4,26.3-25.69,7.02-3.26,14.84-5.07,23.08-5.07,8.65,0,16.84,2,24.12,5.57,11.33,5.52,20.47,14.84,25.79,26.29,3.27,7.03,5.09,14.87,5.09,23.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.52,442.63c0-4.55-.47-7.67-1.4-9.38-.93-1.7-2.54-3.11-4.83-4.21-2.29-1.11-5.77-1.66-10.44-1.66-5.14,0-9.02.92-11.63,2.76-1.14.8-2.14,1.8-2.98,2.99-1.71,2.39-2.53,5.29-2.53,8.22v.57h9.51c0-1.38.36-2.75,1.11-3.9.42-.65.9-1.15,1.42-1.52,1.04-.73,2.5-1.1,4.36-1.1,2.76,0,4.63.43,5.63,1.29.99.86,1.49,2.29,1.49,4.31v1.04c-1.89.8-5.28,1.65-10.18,2.57-3.63.7-6.41,1.51-8.33,2.44-1.93.93-3.42,2.27-4.49,4.03-1.07,1.75-1.6,3.75-1.6,5.98,0,3.38,1.17,6.18,3.52,8.39,2.35,2.21,5.56,3.32,9.64,3.32,2.31,0,4.49-.44,6.52-1.3,2.04-.87,3.95-2.17,5.74-3.91.07.2,0,3.64,0,4.32h9.46v-25.24ZM446.23,450.94c0,2.51-.14,4.21-.41,5.11-.4,1.37-1.23,2.52-2.5,3.47-1.71,1.24-3.52,1.86-5.41,1.86-1.69,0-3.08-.53-4.18-1.6-1.09-1.07-1.64-2.34-1.64-3.8s.68-2.72,2.05-3.69c.89-.6,2.8-1.21,5.7-1.83,2.91-.62,5.03-1.16,6.37-1.6v2.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 468.65,
    cy: 462.9,
    r: 5.86
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(80.25 137.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(749.99 137.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(774.77 809.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(85.16 809.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(85.16 303.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CS"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(754.9 303.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DI"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(85.16 599.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SC"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(754.9 599.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ID"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(341.62 373.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CI"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(516.98 373.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DS"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(341.62 549.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SD"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(516.98 549.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IC"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(563.45 435.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DSI"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(563.45 484.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ICD"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(280.96 122.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CD"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(563.45 122.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DC"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(280.96 792.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SI"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(563.45 792.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IS"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(367.12 208.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CDI"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(474.51 208.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DCS"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(367.12 712.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SID"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(474.51 712.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ISC"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(393.07 322.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CID"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(452.45 322.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DSC"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(391.07 605.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SDI"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(462.45 605.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ICS"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(271.96 264.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CDS"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(555.91 264.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DCI"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(271.96 661.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SIC"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(555.91 661.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ISD"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(213.03 316.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CSD"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(626.29 316.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DIC"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(213.03 599.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCI"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(626.29 599.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IDS"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(167.96 414.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CSI"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(670.79 414.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DIS"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(165.96 505.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCD"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(670.79 505.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IDC"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(280.96 427.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CIS"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(280.96 484.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SDC"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/DISC.2b60616ecbe2ef63bbb19250e4dbc06b.svg";
export { ForwardRef as ReactComponent };